import React from 'react'
import { useQuery } from '@apollo/client'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Dialog from 'components/dialog'
import Box from '@material-ui/core/Box'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import Typography from '@material-ui/core/Typography'
import { GET_GROUP_EVENT_BY_ID } from './queries'
import LinearProgress from '@material-ui/core/LinearProgress'
import GraduateForm from './graduate-form'
import { flags, useFeatureFlags } from 'lib/feature-flags'

const useStyles = makeStyles(theme => ({
  paper: {
    maxHeight: 'calc(100vh - 64px)',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      maxHeight: 'none',
      height: '100%',
    },
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0,
    '& .MuiDialogTitle-root': {
      flexShrink: 0,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
  },
}))

const GraduateModal = ({ trigger, event }) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [isGraduateCardEnabled] = useFeatureFlags([
    flags.FLAG_FEAT_PGA_HOPE_GRADUATE_CARD,
  ])
  const { data, error, loading, refetch } = useQuery(GET_GROUP_EVENT_BY_ID, {
    variables: {
      id: event.id,
    },
  })

  if (loading) return <LinearProgress color="primary" />
  if (error) return <p>Error</p>

  return (
    <Dialog
      trigger={trigger}
      showCloseButton
      fullWidth
      fullScreen={isMobile}
      classes={{ paper: classes.paper }}
    >
      {({ closeDialog }) => {
        return (
          <Box className={classes.root}>
            <DialogTitle>Update Graduate Status</DialogTitle>
            <DialogContent dividers className={classes.content}>
              <Typography
                variant="body1"
                color="textSecondary"
                style={{ flexShrink: 0 }}
              >
                By marking the golfer as a graduate, you are confirming that the
                golfers attended 80% of their PGA HOPE sessions
              </Typography>
              {isGraduateCardEnabled ? (
                <Typography
                  variant="body1"
                  color="textSecondary"
                  style={{ flexShrink: 0, marginTop: 8 }}
                >
                  Graduates receive a digital PGA HOPE card in MyPGA.
                </Typography>
              ) : null}
              <GraduateForm
                event={event}
                enrollments={data?.groupEvents[0]?.enrollments}
                closeDialog={closeDialog}
                refetch={refetch}
              />
            </DialogContent>
          </Box>
        )
      }}
    </Dialog>
  )
}

export default GraduateModal
